// extracted by mini-css-extract-plugin
export var navArea = "nav-area-module--nav-area--Kz67t";